import { z } from "zod";

export const CreateIncidentReportRequestSchema = z.object({
  startDate: z.iso.date(),
  endDate: z.iso.date(),
});

export type SupersetEmbedConfig = {
  dashboardId: string;
  guestToken: string;
  supersetUrl: string;
};

export const SupersetEmbedConfigSchema: z.ZodType<SupersetEmbedConfig> =
  z.object({
    dashboardId: z.string().min(1),
    guestToken: z.string().min(1),
    supersetUrl: z.url(),
  });

export type PowerBiEmbedConfig = {
  dashboardId: string;
  embedUrl: string;
  embedToken: string;
};

export const PowerBiEmbedConfigSchema: z.ZodType<PowerBiEmbedConfig> = z.object(
  {
    dashboardId: z.string().min(1),
    embedUrl: z.url(),
    embedToken: z.string().min(1),
  },
);
export type SupersetDashboardExportRequest = {
  format: "pdf" | "png";
  activeTabs?: string[];
  anchor?: string;
  dataMask?: Record<string, unknown>;
};

export type SupersetDashboardExportResponse = {
  /** Base64 encoded file content */
  data: string;
  contentType: string;
  filename: string;
};
